import React, {FC} from 'react'
import Image from '../../skeleton/ImageComponent';
import {Swiper, SwiperSlide} from 'swiper/react'
import {WhiteNavSwiper} from "./carouselStyle";

interface IMainCarouselProps extends React.ComponentProps<typeof Swiper> {
  itemData: string[];
}

/**
 * MainCarousel component to display a carousel of images using Swiper.
 * Supports all Swiper component props (loop, navigation, pagination, slidesPerView, etc.)
 * @param itemData - Array of image URLs to display in the carousel
 * @param props - Additional Swiper props (loop, slidesPerView, navigation, pagination, modules, etc.)
 * @returns FC<IMainCarouselProps>
 */
const MainCarousel: FC<IMainCarouselProps> = ({
  itemData,
  ...props
}: IMainCarouselProps) => {
  return (
    <WhiteNavSwiper
      {...props}
    >
      {itemData && itemData.map((img, index) => (
        <SwiperSlide key={index}>
          <Image
            errorImg='/app-images/not-found-image/place_holder_image.png'
            placeHolderimg="/app-images/loading/image-loader.gif"
            src={img}
            alt={"gallery-item" + ` ${index + 1}`}
            height="100%"
            width="100%"
          />
        </SwiperSlide>
      ))}
    </WhiteNavSwiper>
  )
}

export default MainCarousel
